import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { TrendingUp, Link2, Award } from "lucide-react";
import api, { apiErr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function Affiliates() {
  const { setUser } = useAuth();
  const navigate = useNavigate();
  const [f, setF] = useState({ name: "", email: "", password: "", social: "", audience: "" });
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/affiliates/register", f);
      localStorage.setItem("sv_token", data.token);
      setUser(data.user);
      toast.success("Application submitted — welcome!");
      navigate("/affiliate/dashboard");
    } catch (err) { toast.error(apiErr(err)); }
    setLoading(false);
  };

  return (
    <div data-testid="affiliates-page">
      <section className="px-6 md:px-12 py-20 text-center border-b hairline">
        <p className="eyebrow mb-4">Ambassador Program</p>
        <h1 className="font-heading text-5xl md:text-6xl tracking-tight mb-6">Share the Voyage.<br/>Earn as You Go.</h1>
        <p className="font-body text-sm text-ink/70 max-w-lg mx-auto leading-relaxed">Join our community of conscious creators. Earn commission on every piece you inspire — with your own referral link and promo code.</p>
        <div className="grid md:grid-cols-3 gap-8 max-w-3xl mx-auto mt-14">
          {[[Link2, "Your Own Link", "Track every click & conversion with a personal referral URL."],
            [Award, "Custom Promo Code", "Give your audience a discount they'll love — and get credit."],
            [TrendingUp, "Real Commission", "Earn on each sale and track unpaid earnings in your dashboard."]].map(([Icon, t, d], i) => (
            <div key={i} className="flex flex-col items-center">
              <div className="w-16 h-16 rounded-full border hairline bg-cream flex items-center justify-center mb-4"><Icon size={26} strokeWidth={1} /></div>
              <h3 className="font-heading text-xl mb-2">{t}</h3>
              <p className="font-body text-sm text-ink/60 leading-relaxed">{d}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="px-6 py-20">
        <div className="max-w-md mx-auto">
          <h2 className="font-heading text-3xl text-center mb-8">Become an Ambassador</h2>
          <form onSubmit={submit} className="space-y-5">
            <input className="input-luxe" placeholder="Full Name" value={f.name} onChange={set("name")} required data-testid="affiliate-name" />
            <input className="input-luxe" type="email" placeholder="Email" value={f.email} onChange={set("email")} required data-testid="affiliate-email" />
            <input className="input-luxe" type="password" placeholder="Create Password" value={f.password} onChange={set("password")} required data-testid="affiliate-password" />
            <input className="input-luxe" placeholder="Social Handle (e.g. @yourname)" value={f.social} onChange={set("social")} data-testid="affiliate-social" />
            <input className="input-luxe" placeholder="Audience / Niche" value={f.audience} onChange={set("audience")} />
            <button className="btn-primary w-full" disabled={loading} data-testid="affiliate-submit">{loading ? "Submitting…" : "Apply Now"}</button>
          </form>
        </div>
      </section>
    </div>
  );
}
